import { render, staticRenderFns } from "./PostAdd.vue?vue&type=template&id=4b722054&scoped=true"
import script from "./PostAdd.vue?vue&type=script&lang=js"
export * from "./PostAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b722054",
  null
  
)

export default component.exports